
import React, { useContext } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { Label } from '@bingads-webui-react/fabric-control';

const getStyles = () => ({
  CampaignName: {
  },
});

export const CampaignName = React.memo((props) => {
  const {
    campaignName,
  } = props;
  const i18n = useContext(I18nContext);
  const classes = useDefaultStyles(getStyles);
  return (
    <div className={classnames('campaign-name', 'section', classes.CampaignName)}>
      <Label>
        {i18n.getString(_TL_('Campaign name'))}
      </Label>
      <div className="name">
        <span>{campaignName}</span>
      </div>
    </div>);
});

CampaignName.propTypes = {
  campaignName: PropTypes.string.isRequired,
};
